module.exports = __webpack_public_path__ + "img/gps.0be3a2e1.svg";